import { OrderState } from '../state/initial-state';

export const orderFullyLoaded: WtrReducer<OrderState, undefined> = state => {
  return {
    ...state,
    fullyLoaded: true,
  };
};
